import {EnglishTranslationsType} from "./enLocale";

const alLocale: Partial<EnglishTranslationsType> = {
    "e-mail": "Adresa e emailit",
    "password": "Fjalëkalimi",
    "existing_user": "Përdorues ekzistues",
    "new_user": "Përdorues i ri",
    "forgot_password": "Keni harruar fjalëkalimin",
    "login": "Hyrje",
    "bad_credentials": "Adresa e emailit ose fjalëkalimi është i pavlefshëm.",
    "your_name": "Emri i plotë",
    "first_name": "Emri",
    "last_name": "Mbiemri",
    "address": "Adresa",
    "register": "Regjistrohu",
    "accept_privacy_and_terms": "Pranoj <0>Politikën e Privatësisë</0> dhe <1>Termat & Kushtet</1>.",
    "read_more": "Lexo më shumë",
    "or_login_with": "ose hyni me",
    "field_required": "Kjo fushë është e detyrueshme.",
    "email_field_not_valid": "Ju lutemi shkruani një adresë emaili të vlefshme.",
    "choose_language": "Zgjidh gjuhën",
    "home": "Ballina",
    "confirm_password": "Konfirmo fjalëkalimin",
    "confirmation_mail_message": "Një email konfirmimi u dërgua në adresën tuaj të emailit.",
    "log_out": "Dil",
    "wishes": "Dëshira",
    "about": "Rreth nesh",
    "logout_success": "Dolët me sukses.",
    "sort_by": "Rendit sipas",
    "password_regex_not_valid": "Kërkesat për fjalëkalimin nuk janë plotësuar.",
    "created_at": "Koha e krijimit",
    "end_time": "Koha e mbetur",
    "tickets_count": "Në trend",
    "times_read": "Shikime",
    "search_wish": "Kërko dëshirë",
    "search": "Kërko",
    "min": "Min",
    "max": "Max",
    "make_a_wish": "Shpreh një dëshirë",
    "days": "Ditë",
    "hours": "Orë",
    "minutes": "Minuta",
    "seconds": "Sekonda",
    "days_short": "D",
    "hours_short": "O",
    "minutes_short": "Min",
    "seconds_short": "Sek",
    "description": "Përshkrimi",
    "specification": "Specifikimet",
    "admin_panel": "Paneli i administratorit",
    "client_panel": "Paneli i klientit",
    "dashboard": "Paneli kryesor",
    "categories": "Kategoritë",
    "tickets": "Bileta",
    "questions": "Pyetje",
    "category": "Kategoria",
    "filters": "Filtra",
    "pending": "Në pritje",
    "completed": "Përfunduar",
    "canceled": "Anuluar",
    "active": "Aktive",
    "finished": "Përfunduar",
    "no_data": "Nuk ka të dhëna",
    "create_wish": "Krijo dëshirë",
    "edit_wish": "Përpuno dëshirën",
    "close": "Mbyll",
    "save": "Ruaj",
    "use": "Përdor",
    "split_by_new_line": "Ndaj me rresht të ri",
    "wish": "dëshirë",
    "delete_wish_confirmation_message": "A jeni i sigurt që dëshironi ta fshini dëshirën me ID:",
    "publish_wish_confirmation_message": "A jeni i sigurt që dëshironi ta publikoni dëshirën me ID:",
    "delete": "Fshij",
    "publish": "Publiko",
    "reset": "Rivendos",
    "create_category": "Krijo kategori",
    "delete_category_confirmation_message": "A jeni i sigurt që dëshironi ta fshini kategorinë me ID:",
    "delete_category": "Fshij kategorinë",
    "scan_winner": "Skano fituesin",
    "enter_info": "Shkruani informacionin",
    "upload_images": "Ngarko imazhe",
    "forgot_password_message": "Shkruani adresën tuaj të emailit dhe ne do t’ju dërgojmë një lidhje për të rivendosur fjalëkalimin.",
    "submit": "Dërgo",
    "reset_password": "Rivendos fjalëkalimin",
    "new_password": "Fjalëkalim i ri",
    "error_forgot_password": "Gabim gjatë dërgimit të emailit për rivendosjen e fjalëkalimit. Provoni përsëri më vonë.",
    "forgot_password_success": "Një email për rivendosjen e fjalëkalimit u dërgua në {{email}}. Kontrolloni emailin dhe klikoni lidhjen për ta rivendosur.",
    "error_reset_password": "Gabim gjatë rivendosjes së fjalëkalimit. Provoni përsëri më vonë.",
    "reset_password_success": "Fjalëkalimi juaj u ndryshua me sukses.",
    "didnt_get_email": "Nuk morët emailin? Kontrolloni nëse adresa e emailit është shkruar saktë.",
    "resend": "Ridërgo",
    "change_email": "Ndrysho emailin",
    "did_you_mean": "A keni dashur të shkruani",
    "link_expired": "Lidhja juaj ka skaduar ose është e pavlefshme. Kërkoni një të re.",
    "requirements": "Kërkesat:",
    "eight_characters": "Të paktën 8 karaktere",
    "include_lowercase": "Përfshin një shkronjë të vogël",
    "include_uppercase": "Përfshin një shkronjë të madhe",
    "include_special": "Përfshin një karakter special",
    "your_profile": "Profili juaj",
    "your_wishes": "Dëshirat tuaja",
    "points": "Pikë",
    "buy_now": "Blej tani",
    "edit_profile": "Përditëso profilin tuaj",
    "city": "Qyteti",
    "phone_number": "Numri i telefonit",
    "update": "Përditëso",
    "success_update_user": "Profili juaj u përditësua me sukses.",
    "error_update_user": "Ndodhi një gabim gjatë përditësimit të profilit tuaj.",
    "vouchers": "Vauçerë",
    "odds": "Shanset për të fituar",
    "winners": "Fitues",
    "winners_announced_on": "Fituesit u shpallen me {{date}}.",
    "you_are_one_of_lucky_winners": "Ju jeni nje nga fituesit me fat!",
    "you_are_not_one_of_lucky_winners": "Ju nuk jeni nje nga fituesit me fat.",
    "winner": "Fitues",
    "see_winners": "Shiko fituesit ({{count}})",
    "login_register": "Hyrje / Regjistrim",
    "see_more": "Shiko më shumë",
    "trending_draws": "Shorte Popullore",
    "partner_vouchers": "Vauçerë nga partnerët",
    "partner_vouchers_subtitle": "Bli vauçerë nga partnerët tanë, shijo përfitimet e tyre dhe fito pikë Genie që ulin koston e hyrjes në short.",
    "how_it_works": "Si funksionon?",
    "how_it_works_jsonld_description": "Ndiq hapat për t’u bashkuar në shorte me hyrje të kufizuara dhe për të rritur shanset për fitore.",
    "home_how_it_works_subtitle": "Merr pjesë në shorte me numër të kufizuar hyrjesh për të fituar çmime të mëdha. Me çdo hyrje i rrit shanset e tua për fitore.",
    "past_winners": "Fituesit e kaluar",
    "lets_begin": "Le të fillojmë",
    "start_wishing": "Realizoni dëshirën tuaj",
    "register_now_and_start_wishing": "Regjistrohuni tani dhe filloni të dëshironi!",
    "learn_more": "Mësoni më shumë",
    "learn_more_rules": "Mësoni më shumë rreth termave tanë",
    "passwords_not_match": "Fjalëkalimet nuk përputhen.",
    "wishlist": "Të preferuara",
    "points_leaderboard": "Renditja e pikëve",
    "cost": "Çmimi",
    "similar_wishes": "Dëshira të ngjashme",
    "back": "Kthehu",
    "something_went_wrong": "Diçka shkoi keq.",
    "working_on_fixing_problem": "Po punojmë për ta rregulluar problemin.",
    "refresh_page": "Rifresko faqen",
    "available_vouchers": "Vauçerë të disponueshëm",
    "bought_vouchers": "Vauçerë të blerë",
    "obtained_entries": "Hyrje të marra",
    "category_popularity": "Popullariteti i kategorisë",
    "start_date": "Data e fillimit",
    "end_date": "Data e mbarimit",
    "bought_vouchers_per_category": "Vauçerë të blerë sipas kategorisë",
    "percentage_total_bought": "Përqindja e vauçerëve të blerë / totali i vauçerëve",
    "displayed_categories": "Kategoritë e shfaqura",
    "users": "Përdorues",
    "new_users": "Përdorues të rinj",
    "proceed_to_payment": "Vazhdo me pagesën",
    "proceed_to_payment_short": "Te pagesa",
    "obtain_more_entries_hint": "Rrit mundësitë për të fituar duke blerë më shumë pjesëmarrje.",
    "continue": "Vazhdo",
    "gender": "Gjinia",
    "male": "Mashkull",
    "female": "Femër",
    "wish_popularity_per_voucher_price": "Popullariteti i dëshirës sipas çmimit",
    "voucher_popularity_per_points_award": "Popullariteti i vauçerëve sipas pikëve të dhëna",
    "users_per_gender": "Përdorues sipas gjinisë",
    "explore_more": "Eksploro më shumë",
    "privacy": "Politika e Privatësisë",
    "privacy_footer": "Privatësia",
    "terms": "Termat & Kushtet",
    "blogs": "Blogje",
    "contact": "Kontakt",
    "legal": "Ligjore",
    "payment_methods": "Mënyrat e pagesës",
    "trusted_partners": "Partnerë të besuar",
    "secure_payments": "Pagesa të sigurta përmes ofruesve të besuar.",
    "all_rights_reserved": "Të gjitha të drejtat e rezervuara.",
    "message": "Mesazh",
    "contact_us": "Na kontaktoni",
    "why_genie": "Pse Genie?",
    "success_create_contact": "Faleminderit! Kemi pranuar mesazhin tuaj dhe do t’ju kontaktojmë sa më shpejt të jetë e mundur.",
    "error_create_contact": "Gabim gjatë dërgimit të mesazhit tuaj. Provoni përsëri më vonë.",
    "load_more": "Shiko më shumë",
    "responded": "U përgjigj",
    "messages": "Mesazhe",
    "expenses": "Shpenzime",
    "create_expense": "Krijo shpenzim",
    "update_expense": "Përditëso shpenzimin",
    "delete_expense": "Fshi shpenzimin",
    "delete_expense_confirmation_message": "A jeni i sigurt që dëshironi ta fshini këtë shpenzim?",
    "expenses_per_month": "Shpenzime sipas muajit",
    "price": "Çmimi",
    "delete_contact_confirmation_message": "A jeni i sigurt që dëshironi ta fshini këtë mesazh?",
    "create_blog": "Krijo blog",
    "update_blog": "Përditëso blogun",
    "delete_blog_confirmation_message": "A jeni i sigurt që dëshironi ta fshini këtë blog?",
    "buy_voucher_one": "Bli vauçer",
    "buy_voucher_other": "Bli vauçerë",
    "confirm": "Konfirmo",
    "you": "Ju",
    "see_wish_details": "Detajet e dëshirës",
    "error_occurred": "Ndodhi një gabim. Provoni përsëri.",
    "error_invalid_request_data": "Disa të dhëna nuk janë të vlefshme. Ju lutemi kontrolloni fushat dhe provoni përsëri.",
    "error_email_address_invalid": "Kjo adresë emaili duket e pavlefshme. Ju lutemi kontrollojeni dhe provoni përsëri.",
    "error_email_domain_not_found": "Nuk mund ta gjejmë domenin e emailit. Kontrolloni nëse ka gabim shtypi (p.sh. gmail.com).",
    "error_email_delivery_failed": "Nuk arritëm të dërgojmë email në këtë adresë. Kontrollojeni ose përdorni një tjetër.",
    "coming_soon": "Së shpejti",
    "points_reward_tooltip": "Pikët që jepen për çdo vauçer të blerë.",
    "page_not_found": "Faqja nuk u gjet",
    "page_not_exist": "Kjo faqe nuk ekziston ose është hequr.",
    "suggest_home": "Ju sugjerojmë të ktheheni në faqen kryesore.",
    "bought": "Blerë",
    "minimum": "Minimumi",
    "maximum": "Maksimumi",
    "notifications": "Njoftime",
    "mark_all_as_read": "Lexoji të gjitha",
    "no_notifications": "Nuk keni njoftime për momentin.",
    "only_unread": "Vetëm të palexuara",
    "subscribe_newsletter": "Dua të marr njoftime me email",
    "error_change_language": "Ndodhi një gabim gjatë ndryshimit të gjuhës.",
    "wheel_spins_dialog_title": "Rrota ditore e pikëve",
    "points_award_dialog_title": "Pikë të dhëna",
    "canceled_order_points_award_title": "Pikë kompensimi për porosi të anuluar",
    "points_history_available_now": "Të disponueshme tani",
    "points_history_status": "Gjendja",
    "points_history_validity": "Vlefshmëria",
    "points_history_status_active": "Aktive",
    "points_history_status_available": "Të disponueshme",
    "points_history_status_partly_used": "Pjesërisht të përdorura",
    "points_history_status_fully_used": "Plotësisht të përdorura",
    "points_history_status_spent": "Të shpenzuara",
    "points_history_status_expired": "Të skaduara",
    "points_history_status_no_expiry": "Pa skadim",
    "points_history_status_used": "Të përdorura",
    "points_history_valid_until": "Vlejnë deri më {{date}}",
    "points_history_expired_on": "Skaduan më {{date}}",
    "points_history_remaining_points": "Të disponueshme tani: {{count}}",
    "points_history_gift_recipient": "Për dhuratë",
    "points_congratulations_one": "Urime! Keni marrë {{count}} pikë.",
    "points_congratulations_other": "Urime! Keni marrë {{count}} pikë.",
    "spin_the_wheel": "Rrotulloni rrotën",
    "spin_the_wheel_points_expiry_notice": "Pikët e fituara nga rrota skadojnë në fund të muajit nëse nuk përdoren.",
    "continue_browsing": "Tani mund të vazhdoni të përdorni aplikacionin.",
    "unsubscribe_success_title": "Çregjistrohu",
    "unsubscribe_success_question": "A jeni i sigurt që dëshironi të çregjistroheni nga njoftimet me email?",
    "unsubscribe_success_description": "U çregjistruat me sukses nga njoftimet me email.",
    "resubscribe_message": "Mund të regjistroheni përsëri duke përditësuar profilin tuaj.",
    "unsubscribe_error": "Gabim gjatë çregjistrimit nga njoftimet me email. Provoni përsëri më vonë.",
    "await_wish_draw": "Shorti është duke u zhvilluar",
    "notification": "Njoftim",
    "send": "Dërgo",
    "notification_send_success": "Njoftimi u dërgua me sukses te përdoruesit e zgjedhur.",
    "notification_send_error": "Gabim gjatë dërgimit të njoftimit. Provoni përsëri.",
    "preview": "Parapamje",
    "history_of_transactions": "Historia e transaksioneve",
    "transaction_id": "ID e transaksionit",
    "date": "Data",
    "amount": "Shuma",
    "status": "Statusi",
    "PENDING": "NË PRITJE",
    "SUCCESSFUL": "SUKSESSHME",
    "FAILED": "E DËSHTUAR",
    "contact_us_subtitle":
        "Për çështje ose mundësi bashkëpunimi — i vlerësojmë komentet tuaja dhe presim të lidhemi me ju.",
    "buy_vouchers_notice":
        "*Duke blerë vauçerë, pranoni <0>Termat & Kushtet</0>. Vauçerët e blerë për këtë dëshirë mund të përdoren deri më: {{expiry}}.",
    "profile_incomplete": "Profili juaj është i paplotë",
    "partners": "Partnerët",
    "view_vouchers": "Shiko vauçerët",
    "view_entries": "Shiko hyrjet",
    "entry_id": "ID e hyrjes",
    "user": "Përdoruesi",
    "payment_status": "Statusi i pagesës",
    "order_id": "ID e porosisë",
    "used_points": "Pikë të shfrytëzuara",
    "winner_voucher": "FITUES",
    "non_winner_voucher": "JO-FITUES",
    "cookie_policy":
        "Përdorim cookies për analiza dhe marketing — më shumë në <0>Politikën e Privatësisë</0>.",
    "accept": "Prano",
    "available": "Disponueshëm",
    "obtained": "Të marra",
    "terminate_wish_confirmation_message":
        "A jeni i sigurt që dëshironi të ndërprisni dëshirën me ID:",
    "terminate": "Ndërprit",
    "terminated": "E ndërprerë",
    "scan_again": "Skano përsëri",
    "all_vouchers_bought": "Nuk ka vauçerë të disponueshëm.",
    "all_entries_obtained": "Nuk ka hyrje të disponueshme.",
    "url_copied": "URL u kopjua në kujtesë",
    "other": "Tjetër",
    "create_update_document": "Krijo / Përditëso dokument",
    "documents": "Dokumente",
    "who_are_we": "Kush jemi ne?",
    "add_new": "Shto të re",
    "effective": "Në fuqi nga:",
    "images": "Imazhe",
    "delete_image_confirmation_message":
        "A jeni i sigurt që dëshironi ta fshini këtë imazh?",
    "config": "Konfigurim",
    "changes_saved_success": "Ndryshimet u ruajtën me sukses.",
    "create_update_config": "Krijo / Përditëso konfigurim",
    "announced": "Shpallur më:",
    "reschedule_wish_confirmation_message":
        "A jeni i sigurt që dëshironi të riplanifikoni shortin për dëshirën me ID:",
    "reschedule": "Riplanifiko",
    "enter_amount": "Shkruani shumën",
    "payment": "Pagesa",
    "confirmation": "Konfirmimi",
    "or_enter_custom_amount": "ose shënoni një shumë tuajën",
    "minimum_amount": "Shuma minimale është {{minimum}}",
    "faq": "Pyetjet e bëra më shpesh",
    "faq_short": "PBMŞ",
    "check_faq_short":
        "Për përgjigje, shikoni <0>Pyetjet e bëra më shpesh</0>. Nëse ende keni nevojë për ndihmë, na dërgoni një mesazh më poshtë!",
    "still_not_clear":
        "Ende keni pyetje? Shikoni <0>Pyetjet e bëra më shpesh</0> ose <1>na dërgoni një mesazh</1> për ndihmë shtesë!",
    "congratulations": "Urime!",
    "you_are_the_lucky_winner": "{{fullName}}, ju jeni një nga fituesit me fat të {{wishName}}!",
    "our_team_will_contact_you":
        "Ekipi ynë do t’ju kontaktojë me detaje se si mund ta merrni shpërblimin tuaj.",
    "this_qr_code_must_be_presented":
        "*Ky kod QR duhet të paraqitet për të marrë shpërblimin tuaj.",
    "install": "Instalo",
    "get_for_seamless_experience": "Shkarkoni aplikacionin Genie për një përvojë të rrjedhshme!",
    "claim_prize": "Merr shpërblimin",
    "expand": "Zgjero",
    "collapse": "Mbyll",
    "this_month": "Këtë muaj",
    "January": "Janar",
    "February": "Shkurt",
    "March": "Mars",
    "April": "Prill",
    "May": "Maj",
    "June": "Qershor",
    "July": "Korrik",
    "August": "Gusht",
    "September": "Shtator",
    "October": "Tetor",
    "November": "Nëntor",
    "December": "Dhjetor",
    "no_active_wishes_title": "Asnjë dëshirë aktive",
    "no_active_wishes_subtitle":
        "Dëshirat aktive në të cilat merrni pjesë do të shfaqen këtu. Eksploroni më shumë dëshira tani!",
    "no_finished_wishes_title": "Asnjë dëshirë e përfunduar",
    "no_finished_wishes_subtitle":
        "Dëshirat e përfunduara ku keni marrë pjesë do të shfaqen këtu. Eksploroni më shumë dëshira tani!",
    "no_wishlist_wishes_title": "Asnjë dëshirë në listën e preferencave",
    "no_wishlist_wishes_subtitle":
        "Dëshirat që ruani do të shfaqen këtu. Eksploroni më shumë dëshira tani!",
    "explore_wishes": "Eksploro dëshirat",
    "send_as_gift": "Dërgo si dhuratë",
    "send_voucher_as_gift_tooltip":
        "Gëzojani ditën dikujt duke i dhuruar një vauçer! Shkruani emrin dhe emailin e tyre dhe do të marrin një mesazh me udhëzime për ta përdorur dhuratën.",
    "send_entry_as_gift_tooltip":
        "Gëzojani ditën dikujt duke i dhuruar një hyrje! Shkruani emrin dhe emailin e tyre dhe do të marrin një mesazh me udhëzime për ta përdorur dhuratën.",
    "recipient_email": "Emaili i marrësit",
    "recipient_name": "Emri i marrësit",
    "personalized_message": "Mesazh i personalizuar",
    "or_enter_manually": "ose shkruani manualisht",
    "voucher_code": "Kodi i vauçerit",
    "help": "Ndihmë",
    "guide": "Udhëzues",
    "discover_guide_text": "Eksploroni udhëzuesin Genie",
    "explore": "Eksploro",
    "check_out_wish": "Shikoni këtë dëshirë — mendojmë se do t’ju pëlqejë!",
    "unsaved_changes_message":
        "Keni ndryshime të paruajtura. Nëse vazhdoni, ato do të humbasin. A jeni i sigurt?",
    "email_send_success": "Emaili u dërgua me sukses.",
    "email_send_error": "Gabim gjatë dërgimit të emailit.",
    "e-mails": "Email-e",
    "optional_fields": "Fusha opsionale",
    "spin_the_wheel_explanation":
        "Përveç mbledhjes së pikëve nga blerja e vauçerëve, mund ta rrotulloni rrotën një herë në ditë për të fituar pikë shtesë.",
    "coming_soon_title": "Dëshirat së shpejti bëhen realitet!",
    "coming_soon_subtitle":
        "Bëhuni ndër të parët që informohen për të gjitha risitë dhe lajmet!",
    "giveaway_note": "Mund të merrni pjesë vetëm një herë në këtë giveaway.",
    "redraw_winners_confirmation_message":
        "A jeni të sigurt që dëshironi të zgjidhni përsëri fituesit për dëshirën me ID:",
    "already_participated": "Jeni tashmë pjesëmarrës në këtë giveaway.",
    "app_description":
        "Merr pjesë në shorte me hyrje të kufizuara për të fituar çmime të mëdha. Bli vauçerë nga partnerët dhe fito pikë Genie që ulin koston e hyrjes në short.",
    "app_keywords":
        "Genie, shorte, shorte me hyrje të kufizuara, lojëra shpërblyese, hyrje, çmime të mëdha, vauçerë partnerësh, pikë Genie, giveaway",
    "app_jsonld_description":
        "Genie është një platformë ueb e fokusuar në shorte me hyrje të kufizuara. Përdoruesit blejnë hyrje për të garuar për çmime të mëdha, dhe gjithashtu mund të blejnë vauçerë nga partnerët për përfitime dhe pikë Genie që ndihmojnë në uljen e kostos së hyrjes në short.",
    "genie_name": "Genie",
    "clients": "Klientët",
    "update_client": "Përditëso klientin",
    "create_client": "Krijo klient",
    "validate_voucher": "Verifiko vauçerin",
    "validate_again": "Verifiko sërish",
    "total": "Totali",
    "expired": "Skaduar",
    "redeemed": "Përdorur",
    "details": "Detaje",
    "bank_fee": "Tarifë bankare",
    "expires": "Skadon",
    "active_voucher": "Aktiv",
    "expired_voucher": "Skaduar",
    "redeemed_voucher": "I përdorur",
    "draw": "Shorte",
    "bundle": "Paketë",
    "draws": "Shorte",
    "comment": "Koment",
    "leave_a_comment": "Opsionale: Lini një koment për vlefshmërinë tuaj të fundit",
    "leave_comment_success": "Komentet për vauçerët gjenden te paneli i klientit.",
    "select_wish_to_start": "Zgjidhni një dëshirë për të filluar.",
    "no_vouchers_yet": "Ende nuk keni vauçerë.",
    "no_wishes_yet": "Ende nuk keni dëshira.",
    "no_draws_yet": "Ende nuk ka shorte.",
    "update_comment": "Përditëso komentin",
    "client_vouchers_bought": "{{bought}}/{{total}} vauçerë të blerë",
    "client_entries_obtained": "{{obtained}}/{{total}} hyrje të marra",
    "voucher": "Vauçer",
    "duplicate_wish_confirmation_message":
        "A jeni i sigurt që dëshironi të kopjoni dëshirën me ID:",
    "duplicate": "Kopjo",
    "entries": "Hyrje",
    "question_step": "Pyetje",
    "create_question": "Krijo pyetje",
    "update_question": "Përditëso pyetjen",
    "delete_question": "Fshij pyetjen",
    "delete_question_confirmation_message": "A je i sigurt që dëshiron ta fshish pyetjen me ID:",
    "answers": "Përgjigje",
    "add_answer": "Shto përgjigje",
    "correct_answer": "Përgjigjja e saktë",
    "question_list_error": "Gabim gjatë ngarkimit të pyetjeve. Ju lutemi provoni përsëri.",
    "question_form_invalid": "Ju lutemi plotësoni të gjitha fushat dhe shënoni një përgjigje të saktë.",
    "question_create_success": "Pyetja u krijua me sukses.",
    "question_create_error": "Gabim gjatë krijimit të pyetjes. Provoni përsëri.",
    "question_update_success": "Pyetja u përditësua me sukses.",
    "question_update_error": "Gabim gjatë përditësimit të pyetjes. Provoni përsëri.",
    "question_delete_success": "Pyetja u fshi me sukses.",
    "question_delete_error": "Gabim gjatë fshirjes së pyetjes. Provoni përsëri.",
    "paying_users": "Përdorues me pagesë",
    "answer_question_to_continue": "Përgjigju saktë për të vazhduar te pagesa.",
    "question_unavailable": "Pyetja nuk është e disponueshme për momentin. Ngarko një pyetje të re.",
    "incorrect_answer_message": "Përgjigje e pasaktë. Nuk mund të vazhdosh me këtë pyetje.",
    "question_answer_wrong_title": "Përgjigje e gabuar",
    "question_answer_wrong_message": "Përgjigjja nuk ishte e saktë, prandaj nuk mund të vazhdosh te pagesa.",
    "question_answer_wrong_hint": "Mbylle këtë dritare dhe provo përsëri me një pyetje të re.",
    "new_question": "Pyetje e re",
    "obtain_entries_confirmation_one":
        "A jeni i sigurt që dëshironi të merrni pjesë me {{count}} hyrje për {{wishName}}?",
    "obtain_entries_confirmation_other":
        "A jeni i sigurt që dëshironi të merrni pjesë me {{count}} hyrje për {{wishName}}?",
    "success_gift_obtain_entries_one":
        "Dhuruat me sukses {{count}} hyrje për këtë dëshirë.",
    "success_gift_obtain_entries_other":
        "Dhuruat me sukses {{count}} hyrje për këtë dëshirë.",
    "success_obtain_entries_one":
        "Morët me sukses {{count}} hyrje për këtë dëshirë. Suksese!",
    "success_obtain_entries_other":
        "Morët me sukses {{count}} hyrje për këtë dëshirë. Suksese!",
    "obtain_entries_notice":
        "*Me pjesëmarrjen në këtë dëshirë, çdo pjesëmarrës pajtohet me <0>Termat & Kushtet</0>.",
    "not_enough_points_message_one":
        "Nuk keni mjaft pikë Genie për të marrë pjesë me {{count}} hyrje për {{wishName}}. Aktualisht keni {{currentPoints}} pikë dhe ju duhen edhe {{missingPoints}}.",
    "not_enough_points_message_other":
        "Nuk keni mjaft pikë Genie për të marrë pjesë me {{count}} hyrje për {{wishName}}. Aktualisht keni {{currentPoints}} pikë dhe ju duhen edhe {{missingPoints}}.",
    "cost_genie_points_one": "Kjo do të kushtojë {{count}} pikë Genie.",
    "cost_genie_points_other": "Kjo do të kushtojë {{count}} pikë Genie.",
    "all": "Të gjithë",
    "wish_type": "Lloji i dëshirës",
    "available_points": "Pikë të disponueshme",
    "subtotal": "Nëntotali",
    "points_discount": "Zbritje me pikë",
    "use_points_for_discount": "Përdor pikë për ta ulur totalin",
    "points_conversion_rate": "1 pikë Genie = 1 MKD",
    "points_to_use": "Pikë për përdorim",
    "max_points_to_use": "Mund të përdorni deri në {{count}} pikë.",
    "spin_again": "Kthehuni pas {{timeLeft}} për ta rrotulluar përsëri!",
    "points_to_use_tooltip": "Pikë Genie të disponueshme që mund t’i përdorësh si zbritje gjatë pagesës së shorteve (1 pikë Genie = 1 MKD).",
    "start_and_free_points": "Regjistrohuni tani dhe merrni {{points}} pikë falas",
    "no_active_wishes": "Nuk ka dëshira aktive. Kontrolloni më vonë!",
    "no_active_wishes_from_type":
        "Nuk ka dëshira aktive të këtij lloji. Kontrolloni më vonë!",
    "free_entry": "Hyrje falas",
    "free_voucher": "Vauçer falas",
    "wish_has_finished": "Kjo dëshirë ka përfunduar",
    "ios_install":
        "Thjesht trokitni <0></0> dhe zgjidhni “Add to Home Screen” për ta instaluar.",
    "view_points_history": "Shiko historikun e pikëve",
    "expenses_per_category": "Shpenzimet sipas kategorisë",
    "change": "Ndryshim",
    "title": "Titull",
    "genie_points": "Pikë Genie",
    "points_used": "Pikë të përdorura",
    "gift_label": "Dhuratë",
    "disable_client_user": "Çaktivizo përdoruesin e klientit",
    "disable_client_user_confirmation_message":
        "A jeni i sigurt që dëshironi të çaktivizoni përdoruesin e klientit me ID: {{id}}",
    "disable_client_user_success":
        "E çaktivizuat me sukses përdoruesin e klientit",
    "generate_report": "Gjenero raport",
    "download": "Shkarko",
    "profit": "Fitim",
    "income": "Të ardhura",
    "income_per_day": "Të ardhurat sipas ditës",
    "income_last_30_days": "Të ardhurat në 30 ditët e fundit",
    "profit_per_month": "Fitimi sipas muajit",
    "all_time": "Gjithsej",
    "all_cities": "Të gjitha qytetet",
    "related_vouchers_message": "Gjetëm kupona shtesë të lidhur me këtë kod. Zgjidhni ata që dëshironi t’i validoni:",
    "validate": "Valido",
    "location": "Vendndodhja",
    "options": "Opsione",
    "from": "nga",
    "left": "{{count}} të mbetura",
    "upload_codes": "Kodet e ngarkimit",
    "update_category": "Përditëso kategorinë",
    "choose_option": "Zgjidh opsionin",
    "obtain_voucher": "Merr vauçerin",
    "already_obtained_voucher": "Tashmë ke një vauçer aktiv.",
    "obtain_voucher_notice": "*Duke marrë këtë vauçer, pajtohesh me <0>Termat & Kushtet</0>. Vauçeri i marrë për këtë dëshirë mund të përdoret deri më: {{expiry}}.",
    "obtain_free_voucher_confirmation": "A je i sigurt që dëshiron ta marrësh këtë vauçer për „{{wish_name}}“?",
    "free_voucher_note": "Mund të kesh vetëm një vauçer aktiv për këtë dëshirë njëkohësisht.",
    "prize_stay_tuned": "Qëndro i informuar për shpërblimin",
    "success_obtain_free_voucher": "E ke marrë me sukses voucherin për këtë dëshirë.",
    "prize_draw": "Shorte",
    "enter_points": "Vendosni pikët",
    "ministry_approval": "Të gjitha shortet janë të aprovuara paraprakisht nga Ministria e Financave e Republikës së Maqedonisë së Veriut.",
    "newsletter_promo_cta": "Ji i pari që merr vesh për të gjitha lajmet tona!"
}

export default alLocale
